define('viewModels/PrivilegedMain',[
    'lib/knockout',
    'lib/lodash4',

    // base classes
    'viewModels/ViewModel',
    'viewModels/SwitchedView',
    'viewModels/NavMenu',
    'viewModels/dashboards/Dashboard',

    // callbacks
    'viewModels/privileged/callbacks/ScheduledCallbacks',

    // qm
    'viewModels/privileged/qm/InteractionsMain',
    'services/qm/recordingNotificationService',

    // Composer - Forms
    'viewModels/privileged/composer/forms/QualityFormsMain',
    
], function (
    ko,
    _,

    // base classes
    ViewModel,
    SwitchedView,
    NavMenu,
    Dashboard,

    // callbacks
    ScheduledCallbacks,

    // qm
    InteractionsMain,
    recordingArchivalService,

    // Composer - Forms
    QualityFormsMain
) {
    'use strict';


    var PrivilegedMain = ViewModel.extend(function () {
        var self = this;

        /**
         * Child views
         */
        self.subViews = self.subView(SwitchedView, {
            dashboard: Dashboard,
            qualityFormsMain: QualityFormsMain,
            interactionsMain: InteractionsMain,
            scheduledCallbacks: ScheduledCallbacks
        });

        self.activeComponent = ko.observable();

        self.subViews.getActiveView.subscribe(function (view) {
            if (view) {
                self.activeComponent(null);
            }
        });

        var lastComponent;
        self.activeComponent.subscribe(function (component) {
            if (component) {
                self.subViews.setActiveView();
            }
            // Dispose the old component
            if (lastComponent && (!component || lastComponent.name != component.name)) {
                disposeComponent(lastComponent);
            }
            lastComponent = component;
        });

        self.onDispose = function () {
            disposeComponent(lastComponent);
        };
    });

    function disposeComponent(component) {
        var componentView = component ? component.data : undefined;
        if (componentView && _.isFunction(componentView.dispose)) {
            componentView.dispose();
        }
    }


    return PrivilegedMain;
});

